<template>
  <!-- TOP Nav Bar -->
  <div class="iq-top-navbar">
    <div
      class="iq-navbar-custom"
      :class="
        horizontal ? 'd-flex align-items-center justify-content-between' : ''
      "
    >
      <div class="iq-sidebar-logo">
        <div class="top-logo">
          <router-link :to="homeURL">
            <img :src="logo" class="img-fluid" alt="logo" />
            <span>{{ appName }}</span>
          </router-link>
        </div>
      </div>
      <!-- <div class="iq-menu-horizontal" v-if="horizontal">
        <div class="iq-sidebar-menu">
          <CollapseMenu
            :items="items"
            :open="true"
            :horizontal="horizontal"
            :sidebarGroupTitle="sidebarGroupTitle"
            class="collapse-menu"
          />
          <HoverMenu
            :items="items"
            :sidebarGroupTitle="sidebarGroupTitle"
            class="hover-menu"
          />
        </div>
      </div> -->
      <nav class="navbar navbar-expand-lg navbar-light p-0">
        <div class="navbar-left" v-if="!horizontal">
          <div class="pl-4">
            <NavbarInvitation />
          </div>
        </div>
        <b-navbar-toggle target="nav-collapse" class="mr-2 text-primary">
          <i class="ri-menu-3-line"></i>
        </b-navbar-toggle>
        <div
          class="iq-menu-bt align-self-center"
          v-if="$route.meta.layout !== 'two-sidebar'"
        >
          <div class="wrapper-menu" @click="miniSidebar">
            <div class="main-circle"><i class="ri-arrow-left-s-line"></i></div>
            <div class="hover-circle">
              <i class="ri-arrow-right-s-line"></i>
            </div>
          </div>
        </div>
        <b-collapse id="nav-collapse" is-nav>
          <slot name="responsiveRight" />
        </b-collapse>
        <div class="mr-3 help-wrapper">
          <b-alert
            :show="true"
            variant=" "
            class="mb-0"
            v-b-tooltip.top="'If you need help using this app, press the icon to get to the support and tutorials page.'"
          >
            <div class="iq-alert-text" stylex="color: #6c757d">
              <span title="Help">
                <a href="https://www.omnicrane.com/en/support" target="_blank"
                  ><i class="ri-question-line mr-1"></i>Help</a
                >
              </span>
            </div>
          </b-alert>
        </div>
        <slot name="right" />
      </nav>
    </div>
  </div>
  <!-- TOP Nav Bar END -->
</template>
<script>
import { APPNAME } from "../../../config/pluginInit";
import { mapGetters } from "vuex";
import HoverMenu from "../menus/HoverMenu";
import GlobalSearch from "../search/GlobalSearch";
import CollapseMenu from "../menus/CollapseMenu";
import NavbarInvitation from "../../../views/Demo/Components/NavbarInvitation.vue";
export default {
  name: "DemoNavbar2",
  props: {
    homeURL: { type: Object, default: () => ({ name: "dashboard" }) },
    logo: { type: String, default: require("../../../assets/images/logo.png") },
    horizontal: { type: Boolean, default: false },
    items: { type: Array },
    sidebarGroupTitle: { type: Boolean, default: true }
  },
  mounted() {
    if (!this.horizontal) {
      document.addEventListener("click", this.closeSearch, true);
    }
  },
  components: {
    HoverMenu,
    GlobalSearch,
    CollapseMenu,
    NavbarInvitation
  },
  computed: {
    ...mapGetters({
      bookmark: "Setting/bookmarkState"
    })
  },
  data() {
    return {
      appName: APPNAME,
      globalSearch: "",
      showSearch: false,
      showMenu: false,
    };
  },
  methods: {
    miniSidebar() {
      this.$emit("toggle");
    },
    openSearch() {
      this.showSearch = true;
      this.showMenu = "iq-show";
      this.globalSearch = "";
      if (document.getElementById("searchbox-datalink") !== null) {
        document
          .getElementById("searchbox-datalink")
          .classList.add("show-data");
      }
    },
    closeSearch(event) {
      const classList = event.target.classList;
      if (
        !classList.contains("searchbox") &&
        !classList.contains("search-input")
      ) {
        this.removeClass();
      }
    },
    removeClass() {
      this.showSearch = false;
      this.showMenu = "";
      this.globalSearch = "";
      if (
        document.getElementById("searchbox-datalink") !== null &&
        document.getElementById("searchbox-datalink") !== undefined
      ) {
        document
          .getElementById("searchbox-datalink")
          .classList.remove("show-data");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.collapse-menu {
  @media (min-width: 1300px) {
    display: none;
  }
}
.iq-sidebar-menu .iq-menu.hover-menu {
  display: flex;
  @media (max-width: 1299px) {
    display: none !important;
  }
}
.help-button {
  display: flex;
  flex-direction: column;
}
.help-button caption {
  font-size: 8px;
  padding: 0;
}
.help-wrapper {
  display: flex;
  flex-direction: row;
}
</style>
